import type { CheckStatus } from "../../../api/content/reviewDecoders";
import type { ChipTone } from "../../../ui/styles/chipStyles";

/** The tone of each check status, wherever a check run's status shows: a not-checked
 * question is neither a pass nor a failure. */
export const CHECK_STATUS_TONE: Readonly<Record<CheckStatus, ChipTone>> = {
  pass: "success",
  fail: "danger",
  cannot_run: "warning",
  not_checked: "neutral",
};
